import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ContractStep } from "../../../../../api/contract/contract-types";
import { PaymentInfo } from "./types";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";

// 서비스 가이드 컴포넌트의 props 인터페이스
interface ServiceTypeGuideProps {
  guideInfo: any; // 가이드 정보
  refundInfo: any; // 환불 정보
  sellerData: any; // 판매자 정보
  contractStatus: ContractStep; // 계약 상태
  payment?: PaymentInfo; // 결제 정보
}

// 서비스 가이드 컴포넌트
const ServiceTypeGuide = ({ guideInfo, refundInfo, sellerData, contractStatus, payment }: ServiceTypeGuideProps) => {
  const { contractId } = useParams();
  const navigate = usePartnerNavigate();
  const { t } = useTranslation("contract");

  // 각 모달 페이지로 이동하는 핸들러 함수들
  const handleNavigateNotionModal = (type: string) => {
    navigate(`/court/mypage/contracts/${contractId}/NotionModal?type=${type}`);
  };
  const handleNavigateRefundPolicy = () => {
    navigate(`/court/mypage/contracts/${contractId}/ServiceTypeRefundPolicy?data=${encodeURIComponent(JSON.stringify(refundInfo))}`);
  };
  const handleNavigateGuide = () => {
    navigate(`/court/mypage/contracts/${contractId}/ServiceTypeGuidelines?data=${encodeURIComponent(JSON.stringify(guideInfo))}`);
  };
  const handleNavigateSeller = () => {
    navigate(`/court/mypage/contracts/${contractId}/SellerModal?data=${encodeURIComponent(JSON.stringify(sellerData))}`);
  };

  return (
    <section className="base-section-layout top-divider">
      <div className="base-section-layout__wrap">
        {/* 유의사항 섹션 */}
        {guideInfo?.initValue && (
          <div className="base-section-layout-line">
            <div className="base-section-layout-index cursor-pointer w-100">
              <div className="mt15 no-wrap" onClick={() => handleNavigateGuide()}>
                <div className="flex-center-between">
                  <span>{t("guide.notes")}</span>
                  <div className="arrow-right"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* 결제 및 취소 안내 섹션 */}
        {refundInfo?.initValue && (
          <div className="base-section-layout-line">
            <div className="base-section-layout-index cursor-pointer w-100">
              <div className="mt15 no-wrap" onClick={() => handleNavigateRefundPolicy()}>
                <div className="flex-center-between">
                  <span>{t("guide.paymentAndCancellationGuide")}</span>
                  <div className="arrow-right"></div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* 판매자 정보 섹션 */}
        <div className="base-section-layout-line">
          <div className="base-section-layout-index cursor-pointer w-100">
            <div className="mt15 no-wrap" onClick={() => handleNavigateSeller()}>
              <div className="flex-center-between">
                <span>{t("guide.sellerInformation")}</span>
                <div className="arrow-right"></div>
              </div>
            </div>
          </div>
        </div>
        {/* 현금영수증 및 세금계산서 발급 안내 섹션 */}
        <div className="base-section-layout-line">
          <div className="base-section-layout-index cursor-pointer w-100">
            <div className="mt15 no-wrap" onClick={() => handleNavigateNotionModal("receipt")}>
              <div className="flex-center-between">
                <span>{t("guide.receiptGuide")}</span>
                <div className="arrow-right"></div>
              </div>
            </div>
          </div>
        </div>
        {/* 개인정보 제3자 제공 동의 섹션 */}
        {payment?.pgcode === "creditcard"
          ? String(contractStatus) === "CONTRACT_ACCEPT" && (
              <>
                <div className="base-section-layout-line">
                  <div className="base-section-layout-index cursor-pointer w-100">
                    <div className="mt15 no-wrap" onClick={() => handleNavigateNotionModal("reservation")}>
                      <div className="flex-center-between">
                        <span>{t("guide.thirdPartyConsent")}</span>
                        <div className="arrow-right"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          : payment?.virtualAccount?.accountNo === undefined ||
            (payment?.virtualAccount?.accountNo === "" && (
              <>
                <div className="base-section-layout-line">
                  <div className="base-section-layout-index cursor-pointer w-100">
                    <div className="mt15 no-wrap" onClick={() => handleNavigateNotionModal("reservation")}>
                      <div className="flex-center-between">
                        <span>{t("guide.thirdPartyConsent")}</span>
                        <div className="arrow-right"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ))}
      </div>
    </section>
  );
};

export default ServiceTypeGuide;
